import { Link } from 'react-router-dom'
import { EmptyState } from '../components/ui'

export function NotFoundPage() {
  return (
    <div className="page-center">
      <EmptyState title="Page not found" body={<Link to="/">Go to the home page</Link>} />
    </div>
  )
}
